<div class="main-grid p-grid p-nogutter">
    <div class="p-col-12 p-md-3">
        <div class="last-refresh">
            <div class="p-grid p-nogutter">
                <div class="p-col-3">
                    <div *ngIf="isMobile && selected">
                        <button pButton icon="pi pi-arrow-left" label="Back" class="p-button-outlined p-button-secondary" (click)="selected = undefined"></button>
                    </div>
                </div>
                <div class="p-col-6 p-md-12 p-text-center">
                    <label>Last Refresh: {{lastRefresh | date: 'HH:mm:ss'}}</label>
                    <p-splitButton (onClick)="refresh()"
                            [icon]="'pi ' + ((loading) ? 'pi-spinner pi-spin' : 'pi-refresh')"
                            [model]="refreshOptions"
                            [disabled]="loading"></p-splitButton>
                </div>
                <div class="p-col-3"></div>
            </div>
        </div>
        <ng-container [ngTemplateOutlet]="(isMobile && selected) ? entryTableTemp : alertTableTemp"></ng-container>
    </div>

    <div class="p-col-12 p-md-9 entry-column">
        <ng-container [ngTemplateOutlet]="entryTableTemp"></ng-container>
    </div>
</div>

<ng-template #alertTableTemp>
    <p-divider></p-divider>
    <div *ngIf="!model.length && !loading" class="p-text-center p-mt-3">
        <label>
            No alerts to display
        </label>
    </div>
    <p-table #alertTable
             *ngIf="model.length"
             [value]="model"
             [(selection)]="selected"
             [scrollable]="true"
             scrollHeight="flex"
             selectionMode="single">
        <ng-template pTemplate="body" let-entry>
            <tr [pSelectableRow]="entry">
                <td>{{ entry.alert.name }}</td>
            </tr>
        </ng-template>
    </p-table>
</ng-template>

<ng-template #entryTableTemp>
    <div *ngIf="!selected && model.length" class="p-text-center">
        Select an alert to view statuses here
    </div>
    <div *ngIf="selectedHasInitStatuses" class="p-text-center init-status-div">
        <label>
            <span>Show all statuses</span>
            <p-inputSwitch [(ngModel)]="showInitStatuses"></p-inputSwitch>
        </label>
    </div>
    <p-table *ngIf="selected"
             [value]="selectedEntries"
             sortMode="multiple"
             [multiSortMeta]="defaultSort"
             [scrollable]="true"
             scrollHeight="flex"
             [rowHover]="true"
             (sortFunction)="sortSelected($event)"
             [customSort]="true">
        <ng-template pTemplate="colgroup">
            <colgroup>
                <col style="width:250px">
                <col style="width:250px">
                <col style="width:250px" *ngFor="let parameter of selectedParameters">
            </colgroup>
        </ng-template>
        <ng-template pTemplate="caption">
            <div class="p-text-center">
                {{selected.alert.name}}
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th pSortableColumn="created">
                    <p-sortIcon field="created"></p-sortIcon>
                    Timeframe
                </th>
                <th pSortableColumn="status">
                    <p-sortIcon field="status"></p-sortIcon>
                    Status
                </th>
                <th *ngFor="let param of selectedParameters"
                    [pSortableColumn]="param.id.toString()">
                    <p-sortIcon [field]="param.id.toString()"></p-sortIcon>
                    <span>
                            <span *ngIf="param.key || param.required"
                                  [ngClass]="'fa fa-' + (param.key ? 'key' : 'exclamation')">
                            </span>
                        {{ param.name }}
                        </span>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-entry>
            <tr *ngIf="entry.event.status.id !== 5 || showInitStatuses">
                <td>
                    <span *ngIf="!entry.event.note">
                        {{ entry.event.created | date: 'MM-dd-YYYY HH:mm' }}
                    </span>
                    <a *ngIf="entry.event.note" href="/#/note-detail?log={{entry.event.note.logId}}&note={{entry.event.note._links.self.href}}">
                        {{ entry.event.created | date: 'MM-dd-YYYY HH:mm' }}
                    </a>
                </td>
                <td>{{entry.event.status.name}}</td>
                <td *ngFor="let value of entry.values" [ngClass]="{'p-text-right': selected.alignmentMap[value.id]}">
                    {{ value.displayValue }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</ng-template>